import { InMemoryCache, InMemoryCacheConfig } from '@apollo/client';

interface Args {
  generatedGraphqlPossibleTypes: InMemoryCacheConfig['possibleTypes'];
}

export const createApolloClientCache = ({
  generatedGraphqlPossibleTypes,
}: Args): InMemoryCache =>
  new InMemoryCache({
    possibleTypes: generatedGraphqlPossibleTypes,
    typePolicies: {},
  });

export default createApolloClientCache;
